import { render, staticRenderFns } from "./legal-advice.vue?vue&type=template&id=3efa4eb6&scoped=true&"
import script from "./legal-advice.vue?vue&type=script&lang=js&"
export * from "./legal-advice.vue?vue&type=script&lang=js&"
import style0 from "./legal-advice.vue?vue&type=style&index=0&id=3efa4eb6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efa4eb6",
  null
  
)

export default component.exports